import script from "./userAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./userAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./userAddEditDialog.vue?vue&type=style&index=0&id=616e8300&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616e8300"]])

export default __exports__